module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "front"
  }, [_vm._v("Then I saw that there was a way to hell, even from the gates of heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN BUNYAN")]), _vm._v(": "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Pilgrim’s Progress")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("O where is tinye Hew?"), _c('br'), _vm._v("And where is little Lenne?"), _c('br'), _vm._v("And where is bonny Lu?"), _c('br'), _vm._v("And Menie of the Glenne?"), _c('br'), _vm._v("And where’s the place of rest—"), _c('br'), _vm._v("The ever changing hame?"), _c('br'), _vm._v("Is it the gowan’s breast,"), _c('br'), _vm._v("Or ‘neath the bells of faem?")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ay, lu, lan, dil y’u")]), _vm._v(" "), _c('p', {
    staticClass: "righta"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ANON")]), _vm._v(": "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Gloamyne Buchte")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Wir holen sie ein auf jenen Höh’n"), _c('br'), _vm._v("Im Sonnenschein."), _c('br'), _vm._v("Der Tag ist schön auf jenen Höh’n")]), _vm._v(" "), _c('p', {
    staticClass: "righta"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIEDRICH RÜCKERT")]), _vm._v(":"), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kindertotenlieder IV")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa306ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Front.vue
// module id = 75
// module chunks = 0